/**
 * Created by tschenkel on 6/30/2015.
 */

/**
 * List all supported processor types.
 */
export class ProcessorTypeConstants {
    public static PROCESSOR_GLOBALIZE: string = "PROCESSOR_GLOBALIZE";
}
